import { render, staticRenderFns } from "./AdminStadium.vue?vue&type=template&id=3a3f9830&"
import script from "./AdminStadium.vue?vue&type=script&lang=js&"
export * from "./AdminStadium.vue?vue&type=script&lang=js&"
import style0 from "./AdminStadium.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a3f9830')) {
      api.createRecord('3a3f9830', component.options)
    } else {
      api.reload('3a3f9830', component.options)
    }
    module.hot.accept("./AdminStadium.vue?vue&type=template&id=3a3f9830&", function () {
      api.rerender('3a3f9830', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminStadium.vue"
export default component.exports